import $ from 'jquery';

$(document).on('ready turbo:load turbo:frame-load', function () {
  const containers = $('.detailTabs');

  return containers.each(function (index, container): void {
    const tabs = $(container).find('> .detailTabs-tabs > .detailTabs-tab');
    const panes = $(container).find(
      '> .detailTabs-content > .detailTabs-contentPane'
    );

    tabs.each(function (index, tab): void {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        index = tabs.index(tab);
        tabs.removeClass('active');
        panes.removeClass('active');
        $(tabs.get(index)!).addClass('active');
        $(panes.get(index)!).addClass('active');
      });
      tabs.first().addClass('active');
      panes.first().addClass('active');
    });
  });
});
